import { render, staticRenderFns } from "./ExchangeRateFieldset.yaml?vue&type=template&id=67d2fc65&component"
import script from "./ExchangeRateFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./ExchangeRateFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports